import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { normalizeIds } from '@/utils/ids';

import { TSearchSimpleEntity } from '../types';

import { searchQueryKeys } from './query-keys';

export async function getSearchesByIds(ids: string[]): Promise<TSearchSimpleEntity[]> {
  return mediaManagerClient
    .get('api/v1/searches/by_ids', { params: { ids: ids.join(',') } })
    .then(({ data }) => data);
}

type QueryFnType = typeof getSearchesByIds;

interface UseSearchesByIdsParams {
  ids: string[];
  config?: Omit<QueryConfig<QueryFnType>, 'enabled'>;
}

export function useSearchesByIds({ ids, config = {} }: UseSearchesByIdsParams) {
  const uniqueIds = normalizeIds(ids);

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: searchQueryKeys.searchesByIds(uniqueIds),
    queryFn() {
      return getSearchesByIds(uniqueIds);
    },
    enabled: uniqueIds.length > 0,
  });
}
